import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "skeleton"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"skeleton-top\"><div class=\"skeleton-text\"><h4 class=\"skeleton-title\"></h4><div class=\"line\"></div><div class=\"line last-line\"></div></div><div class=\"skeleton-img\"></div></section><div class=\"skeleton-info\"><span class=\"data\"></span><span class=\"view\"></span><span class=\"like\"></span></div>", 2);
const _hoisted_4 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}